import type { MailboxInfo } from 'owa-client-types';
import type MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import updateMailboxJunkEmailConfiguration from './updateMailboxJunkEmailConfiguration';
import {
    setMailboxJunkEmailConfiguration,
    JunkEmailConfigurationErrorCode,
} from '../services/setMailboxJunkEmailConfiguration';

export default async function saveMailboxJunkMailConfiguration(
    mailboxJunkEmailConfiguration: MailboxJunkEmailConfigurationOptions,
    mailboxInfo: MailboxInfo
): Promise<JunkEmailConfigurationErrorCode> {
    return setMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration, mailboxInfo).then(
        result => {
            if (result === JunkEmailConfigurationErrorCode.None) {
                updateMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration, mailboxInfo);
            }
            return result;
        }
    );
}
